import styled from 'styled-components';

export const DialogWrapper = styled.div<{
  show: boolean;
  zIndex: number;
}>`
  position: fixed;
  z-index: ${(prop) => prop.zIndex};
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(prop) => (prop.show ? '1' : '0')};
  visibility: ${(prop) => (prop.show ? 'visible' : 'hidden')};
  transition: opacity 0.4s ease, visibility 0.4s ease;
  background-color: rgba(40, 48, 68, 0.6);
`;

export const DialogContent = styled.div<{
  maxWidth: string;
  show: boolean;
}>`
  position: relative;
  padding-top: 56px;
  max-height: calc(100% - 48px);
  width: calc(100% - 48px);
  max-width: ${(prop) => prop.maxWidth};
  border-radius: 8px;
  opacity: ${(prop) => (prop.show ? '1' : '0')};
  visibility: ${(prop) => (prop.show ? 'visible' : 'hidden')};
  overflow-y: auto;
  background-color: #ffffff;
`;

export const DialogButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  transition: background-color 0.4s ease;
  background-color: #ffffff;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    height: 2px;
    width: 16px;
    border-radius: 8px;
    background-color: #fc4a61;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {
    background-color: #fed4d6;
  }
`;
